export default __webpack_public_path__ + "static/media/sh_9.b9f7e030.png";